<!--新增党建引领-->
<template>
    <div class="app-container">
        <div class="x-nav">
            <el-breadcrumb :separator="'＞'">
                <el-breadcrumb-item><a @click="backList">美育浸润管理</a></el-breadcrumb-item>
                <el-breadcrumb-item v-if="!myjrId">新增</el-breadcrumb-item>
                <el-breadcrumb-item v-if="myjrId">编辑</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="never" style="height: calc(100vh - 160px);overflow: auto;">
            <el-form style="padding-bottom: 15px;" ref="form" :model="form" :rules="rules" label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="标题" prop="myjrName">
                            <el-input v-model="form.myjrName" placeholder="请输入标题"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="学段" prop="periodKey">
                            <el-select @change="changePeriod"  v-model="form.periodKey" placeholder="请选择">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="年级" prop="gradeKey">
                            <el-select v-model="form.gradeKey" placeholder="请选择">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="年级段" prop="myjrGrade">
                            <el-select v-model="form.myjrGrade" placeholder="请选择">
                                <el-option v-for="item in myjrGradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="主题" prop="myjrItem">
                            <el-select v-model="form.myjrItem" placeholder="请选择">
                                <el-option v-for="item in itemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName"
                                           :value="item.itemId" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="类型" prop="myjrType">
                            <el-select v-model="form.myjrType" placeholder="请选择">
                                <el-option v-for="item in typeList" :key="item.value" :label="item.name"
                                           :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="16">
                        <el-form-item label="音乐文件" prop="fileList">
                            <el-upload v-model:file-list="form.fileList" style="width: 100%"
                                       :limit="1"
                                       :action="serviceUrl+'/businessservice/myjr/annexUpload'"
                                       :on-remove="handleFileRemove" :headers="{ token }" accept=".MP3,.mp3,"
                                       :before-upload="beforeFileUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.mp3,格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="18">
                        <el-form-item label="介绍" prop="raceOverview">
                            <el-input type="textarea" rows="5" v-model="form.myjrIntroduction" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>

        <div>
            <div class="disflex-row-center cusbtbtn" :style="$store.state.zdy.isActive ? 'left:26px;' : 'left:226px;'">
                <el-button @click="backList">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import TEditor from '@/components/TEditor.vue';
import { serviceUrl } from "@/utils/global"
import {queryDict} from "@/api/admin/public";
import {listItem} from "@/api/admin/item"
import {createMyjr,updateMyjr,infoMyjr} from "@/api/admin/myjr"

export default {
    name: "myjrCreate",
    components: {
        TEditor
    },
    data() {
        return {
            token: this.$storage.get("token"),
            serviceUrl,
            // 遮罩层
            loading: true,
            myjrId:'',
            fileList:[],
            periodList:[],
            gradeList:[],
            myjrGradeList:[],
            itemList:[],
            typeList: [
                { name: '音乐', value: 1 },
                // { name: '美术', value: 2 },
                // { name: '主题班会', value: 3 },
            ],
            // 表单参数
            form: {
                myjrId:'',
                myjrName: '',
                myjrUrl:'',
                periodKey:'',
                gradeKey:'',
                myjrType:1,
                myjrItem:'',
                myjrGrade:'',
                myjrIntroduction:'',
                fileList:[],
            },
            rules:{
                myjrName: [{ required: true, message: "请输入标题", trigger: "blur" },],
                periodKey: [{ required: true, message: "请选择", trigger: "change" },],
                myjrGrade: [{ required: true, message: "请选择", trigger: "change" },],
                myjrType: [{ required: true, message: "请选择", trigger: "change" },],
                myjrItem: [{ required: true, message: "请选择", trigger: "change" },],
                fileList: [{ required: true, validator: this.checkFileList  },],
            },
        };
    },
    created() {
        this.getQueryDict();
        this.queryItemList()
    },
    mounted() {
        if (this.$route.query.myjrId) {
            this.myjrId = this.$route.query.myjrId
            this.queryMyjrInfo()
        }
    },
    computed: {},
    methods: {
        checkFileList(rule, value, callback) {
            // rule规则对象
            // value关联表单值
            // callback() 回传结果
            if (this.form.fileList.length === 0) {
                callback(new Error('请上传文件'))
            } else {
                callback()
            }
        },
        queryItemList(){
            listItem({ itemType: 1 }).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        changePeriod() {
            this.form.gradeKey = '';
            this.gradeList = [];
            this.periodList.forEach(j => {
                if (this.form.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'myjr_grade_period' }).then(res => {
                this.myjrGradeList = res.data.data;
            })
        },
        queryMyjrInfo(){
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                  this.periodList = res.data.data;
                infoMyjr({ myjrId: this.myjrId }).then(res => {
                    if (res.data.code === 1) {
                        this.form = res.data.data;
                        this.periodList.forEach(j => {
                            if (this.form.periodKey == j.dictKey) {
                                this.gradeList = j.childrenList;
                            }
                        })
                        this.form.fileList = []
                        this.form.fileList.push({
                            name: this.form.file.fileName,
                            fileId: this.form.file.fileId,
                            url: this.form.file.fileUrl,
                            response: {
                                data: this.form.file.fileUrl
                            }
                        })
                    }else {
                        this.$message.error("操作失败")
                    }
                })
            });

        },
        submitForm(){

            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.form.myjrUrl = this.form.fileList[0].response.data
                    if (!this.myjrId) {
                        createMyjr(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("操作成功");
                                this.backList();
                            }else {
                                this.$message.error("操作失败")
                            }
                        })
                    }else {
                        this.form.myjrId = this.myjrId;
                        updateMyjr(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("操作成功");
                                this.backList();
                            }else {
                                this.$message.error("操作失败")
                            }
                        })
                    }
                }
            });
        },
        backList(){
            this.$router.push({
                path: "/myjr",
            });
        },

        handleFileRemove(file, uploadFiles) {
            this.form.fileList = [];
        },
        beforeFileUpload(rawFile) {

            return true
        },
    }
}
</script>

<style scoped>

</style>